var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-icon"},[_c('el-tooltip',{attrs:{"content":_vm.content,"placement":"bottom","effect":"light"}},[_c('i',{staticClass:"el-icon-warning"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }